webpackJsonp([56635243537030],{

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/esfera.ce9775f6.png";

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/esferasaude.c69021d0.jpg";

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/favicon.0af11031.ico";

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(77);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _esferasaude = __webpack_require__(530);
	
	var _esferasaude2 = _interopRequireDefault(_esferasaude);
	
	var _esfera = __webpack_require__(529);
	
	var _esfera2 = _interopRequireDefault(_esfera);
	
	var _favicon = __webpack_require__(49);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'ESFERA SA\xDADE'
	            ),
	            _react2.default.createElement('link', { rel: 'shortcut icon', type: 'image/png', href: _favicon2.default })
	        ),
	        _react2.default.createElement('span', { className: 'image main' }),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'image midlogo' },
	                            _react2.default.createElement('img', { src: _esfera2.default, alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _esferasaude2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Desde 2008 que a Esferasa\xFAde faz tudo com o cora\xE7\xE3o. Ap\xF3s uma fase de expans\xE3o e de forte investimento, consolidamos a nossa aposta e mudamos hoje para uma estrutura mais simples. De cl\xEDnicas especializadas na \xE1rea dos Meios Complementares de Diagn\xF3stico passamos a Unidades M\xE9dicas Especializadas de tratamento e diagn\xF3stico. Temos agora uma identidade diferente, mais madura e s\xF3lida mas queremos continuar a ser vitais para a vida dos nossos utentes e capazes de feitos extraordinariamente importantes. Conte com uma equipa especializada. Conte com a Esferasa\xFAde.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Desenvolver, de forma sustentada, os melhores cuidados de sa\xFAde. Diferenciando-nos pelo rigor, \xE9tica e profissionalismo e por um ambiente humano e pr\xF3ximo, de absoluto respeito e empatia por todos quantos nos procuram. Trabalhamos com os melhores profissionais, promovendo o seu desenvolvimento cont\xEDnuo, numa cultura de exig\xEAncia e busca permanente da excel\xEAncia.'
	                    ),
	                    _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.esferasaude.pt/', className: 'button' },
	                            'Saber mais'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-esfera-js-56038ed7624a6f4aeb37.js